import { SxProps, TextFieldProps } from '@mui/material';

import TextFieldSearchBar from './TextFieldSearchBar';
import AutocompleteSearchBar, { OptionType } from './AutocompleteSearchBar';

interface GenericSearchBarPropsBase {
    placeholder: string;
    value: string;
    onClear?: () => void;
    inputRef?: React.RefObject<HTMLInputElement>;
    sx?: SxProps;
    style?: React.CSSProperties;
}

interface TextFieldSearchBarProps extends GenericSearchBarPropsBase {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface AutocompleteSearchBarProps extends GenericSearchBarPropsBase {
    autoCompleteOptions: OptionType[];
    onChange: (event: React.SyntheticEvent<Element, Event>, value?: string | null) => void;
    onBlur?: () => void;
    textFieldProps?: Partial<TextFieldProps>;
}

type GenericSearchBarProps = TextFieldSearchBarProps | AutocompleteSearchBarProps;

function GenericSearchBar({ ...props }: GenericSearchBarProps) {
    if ('autoCompleteOptions' in props) {
        const { autoCompleteOptions, onChange, textFieldProps, ...restProps } = props;
        return (
            <AutocompleteSearchBar
                {...restProps}
                options={autoCompleteOptions}
                onChange={(event, value) => onChange(event, value)}
                textFieldProps={textFieldProps}
            />
        );
    }

    const { onChange, ...restProps } = props;

    return (
        <TextFieldSearchBar {...restProps} onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event)} />
    );
}

export default GenericSearchBar;
